import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { deleteVFL, getVFL } from "app/_services/ehs/VFLService";
import { FiEdit3, FiEye } from "react-icons/fi";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { Link } from "react-router-dom";
import { ACTIVE_MODULE, moduleType } from "app/_constants/constant";
import {
  isUserMM,
  isUserSO,
  isUserVFLOfficer,
  IS_USER_SITE_HO,
  LOGGED_IN_USER_SITE_ID,
  LOGGED_USER_ID,
} from "../IncidentManagement/Helper";
import { FaRegTrashAlt } from "react-icons/fa";
import {
  checkVflStatusFilter,
  contractorInvolvedView,
  getVFLStatusClass,
  incidentFilterFields,
  VFL_STATUS,
  VFL_STATUS_COLUMN,
  VFL_STATUS_VIEW,
} from "./CONSTANTS";
import { confirmAlert } from "react-confirm-alert";
import toastr from "toastr";
import { SITE_TYPE } from "app/_constants/constant";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  filterActionAdd,
  filterActionManageVFLFilter,
} from "../TrainingManagement/Assign/ReducerForAssign";
import VFLFilters from "./component/VFLFilters";
import { useForm } from "app/_helpers/hooks";
import { validateRowFilter } from "../IncidentManagement/CONSTANTS";
import {
  DDMMYYYYFormat,
  DDMMYYYYHHMMAFormat,
  isBetween,
  YYYYMMDDFormat,
} from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import DeleteRecordIcon from "app/Components/DeleteRecordIcon/DeleteRecordIcon";

function ManageVFL() {
  const [VFLList, setVFLList] = useState([]);
  const [tableVFLList, setTableVFLList] = useState([]);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, incidentFilterFields);
  // const [VFLFilter, setVFLFilter] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const onReset = () => setFilterForm({});

  const deleteRow = useCallback((e, id) => {
    e.preventDefault();

    confirmAlert({
      title: "Delete Role",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await deleteVFL(id);

            if (!response?.status) return toastr.info(response?.message);

            toastr.info(response?.message || "Deleted Successfully!");
            getVflList();
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }, []);

  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "vflId",
        text: "VFL Id",
        sort: true,
        formatter: (vflId, row) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
          >
            <Link
              className="icons text-cyanBlue"
              to={
                row.vflStatus === VFL_STATUS.completed
                  ? "/health-safety-and-environment/vfl/completion/view/" + row.id
                  : "/health-safety-and-environment/vfl/view/" + row.id
              }
            >
              {vflId}
            </Link>
          </OverlayTrigger>
        ),
      },
      {
        dataField: "mineName",
        text: "Location Name",
        sort: true,
      },
      {
        dataField: "siteData.siteId",
        text: "Location Code",
        sort: true,
        formatter: (ehsSite, row) => {
          return (
            <span title={row?.siteData ? row?.siteData?.name : ""}>
              {row?.siteData ? row?.siteData?.siteId : ""}
            </span>
          );
        },
      },
      {
        dataField: "vflExecutiveName",
        text: "VFL Executive",
        sort: true,
      },
      {
        dataField: "vflExecutionDateFormatted",
        text: "VFL Conducted On",
        sort: true,
      },
      {
        dataField: "ehs_area_of_operations.name",
        text: "Area",
        sort: true,
      },
      {
        dataField: "departmentId",
        text: "Department",
        sort: true,
      },
      {
        dataField: "contractorInvolved",
        text: "Contractor",
        sort: true,
        formatter: (contractorInvolved, row) => {
          return contractorInvolvedView[row?.contractorInvolved];
        },
      },
      // {
      //   dataField: "vflScheduledDateTimeView",
      //   text: "VFL Scheduled Date",
      //   sort: true,
      // },
      {
        dataField: "vflStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return VFL_STATUS_COLUMN(row?.vflStatus, row);
        },
      },
      {
        dataField: "createdAt",
        text: "Time Stamp",
        sort: true,
        formatter: (createdAt, row) => {
          return DDMMYYYYHHMMAFormat(createdAt);
        },
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          let editLink = null;
          if (row.vflStatus) {
            if (
              row.vflStatus === "scheduled" &&
              isUserMM() &&
              ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
                (row.vflAssignerSiteType === SITE_TYPE.mines &&
                  LOGGED_IN_USER_SITE_ID() === row.mineId))
            ) {
              editLink = "/health-safety-and-environment/vfl/schedule/" + row.id;
            } else if (
              [VFL_STATUS.assigned, VFL_STATUS.executed].includes(row.vflStatus) &&
              isUserVFLOfficer() &&
              LOGGED_USER_ID() === row.vflExecutiveId
            ) {
              editLink = "/health-safety-and-environment/vfl/completion/" + row.id;
            } else if (
              row.vflStatus === VFL_STATUS.capaCompleted &&
              isUserSO() &&
              ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
                (row.vflAssignerSiteType === SITE_TYPE.mines &&
                  LOGGED_IN_USER_SITE_ID() === row.mineId))
            ) {
              editLink = "/health-safety-and-environment/vfl/so-completion/" + row.id;
            } else if (
              row.vflStatus === VFL_STATUS.capaReviewed &&
              isUserMM() &&
              ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
                (row.vflAssignerSiteType === SITE_TYPE.mines &&
                  LOGGED_IN_USER_SITE_ID() === row.mineId))
            ) {
              editLink = "/health-safety-and-environment/vfl/mm-completion/" + row.id;
            }
          }

          let deleteLink = false;
          if (
            row.vflStatus &&
            [VFL_STATUS.scheduled, VFL_STATUS.assigned].includes(row.vflStatus) &&
            isUserMM()
          ) {
            if (
              (row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
              (row.vflAssignerSiteType === SITE_TYPE.mines &&
                LOGGED_IN_USER_SITE_ID() === row.mineId)
            )
              deleteLink = true;
          }

          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={
                    row.vflStatus === VFL_STATUS.completed
                      ? "/health-safety-and-environment/vfl/completion/view/" + row.id
                      : "/health-safety-and-environment/vfl/view/" + row.id
                  }
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>

              <DeleteRecordIcon
                id={row.id}
                moduleType={moduleType.ehs_vfls}
                setLoading={setLoading}
                reloadData={getVflList}
              />

              {/* {editLink && (
                <CustomTooltip tooltip={"Edit"}>
                  <Link to={editLink} className="icons text-cyanBlue">
                    <FiEdit3 />
                  </Link>
                </CustomTooltip>
              )}

              {deleteLink && (
                <CustomTooltip tooltip={"Delete"}>
                  <span
                    onClick={(e) => deleteRow(e, row.id)}
                    className="icons text-danger pointer"
                  >
                    <FaRegTrashAlt />
                  </span>
                </CustomTooltip>
              )} */}
            </div>
          );
        },
      },
    ],
    [deleteRow]
  );

  useEffect(() => {
    getVflList();
  }, []);

  const getVflList = async () => {
    // getVFL().then((response) => {
    //   if (!response?.status) return;

    //   setVFLList(
    //     response.data.map((ele) => {
    //       if (ele?.contractorInvolved) {
    //         ele.contractorInvolved = "yes";
    //       }
    //       if (!ele?.contractorInvolved) {
    //         ele.contractorInvolved = "no";
    //       }
    //       return ele;
    //     })
    //   );
    const response = await getVFL();

    if (!response?.data) {
      // Handle the case where data is not received
      setLoading(false);
      return;
    }

    setVFLList(
      response.data.map((ele) => {
        if (ele?.contractorInvolved) {
          ele.contractorInvolved = "yes";
        }
        if (!ele?.contractorInvolved) {
          ele.contractorInvolved = "no";
        }
        return {
          ...ele,
          vflStatusView: !ele?.executiveReturn
            ? VFL_STATUS_VIEW[ele?.vflStatus]
            : VFL_STATUS_VIEW?.ExecutiveReturn,
          vflExecutiveName: ele?.vflOfficerData
            ? `${ele?.vflOfficerData?.firstName} ${ele?.vflOfficerData?.lastName}`
            : "",
          vflExecutionDateFormatted: ele?.vflExecutionDateTime
            ? DDMMYYYYFormat(`${ele?.vflExecutionDateTime}`)
            : "",
        };
      })
    );

    setLoading(false);
  };

  // useEffect(() => {
  //   setTableVFLList(VFLList);
  // }, [VFLList]);

  useEffect(() => {
    // if (filterForm.hasOwnProperty("contractorInvolved")) {
    //   if (filterForm.contractorInvolved === "") filterForm.contractorInvolved = 0;
    // }
    setTableVFLList(
      VFLList?.filter?.((data) => {
        let flag = true;
        if (filterForm?.startDate && filterForm?.endDate) {
          flag = isBetween(
            data.vflScheduledDateTime,
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (filterForm?.vflStatus && flag) {
          flag = checkVflStatusFilter(filterForm?.vflStatus, data);
        }

        if (flag) flag = validateRowFilter(filterForm, data);

        return flag;
      })
    );
  }, [VFLList, filterForm]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <VFLFilters
        fields={incidentFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Visible Felt Leadership",
            path: "/health-safety-and-environment/vfl",
          },
          {
            name: "View VFLs",
          },
        ]}
        module={ACTIVE_MODULE.vfl}
        breadCrumbsText="User_Management_User_Registration"
      />

      <div className="card p-3 mt-4">
        <div className="simple-card-title mb-3">
          <h3 class="text-capitalize mb-0">View VFLs</h3>
          <FilterBtn setShowFilter={setShowFilter} />
          <BackBtn url={"/health-safety-and-environment/vfl"} />
        </div>
        {!loading ? (
          <SearchBootstrapTable
            searchKey={"viewVFLDesktopSearch"}
            data={tableVFLList.filter((d) => d.vflStatus != "draft")}
            columns={sortableColumn}
            tableBeforeSearch={tableToolbarBeforeView}
            tableKey="viewVFL"
            defaultHideColumn={["mineName"]}
          />
        ) : (
          <NetZeroLoader />
        )}
      </div>
    </div>
  );
}

export default ManageVFL;
